import React from "react";

export default  function SuccessLogin(){

    return <>Redirected Sucessfully</>
}